import React from 'react';
import ChampionsLayout from '../../components/layout/ChampionsLayout';
import ReferralContent from '../../components/referral/ReferralContent';

const ChampionsReferralWrapper = () => {
  return (
    <ChampionsLayout>
      <ReferralContent isChampions={true} />
    </ChampionsLayout>
  );
};

export default ChampionsReferralWrapper;
